import React from 'react';
import { Show } from '@refinedev/antd';
import { useShow } from '@refinedev/core';
import { Tag, theme } from 'antd';
import { ContentPageDto, ContentStatus } from '@wellverse/shared-ts';
import { Field } from '../../components/Field';
import { LocalizedContentShow } from '../../components/LocalizedContentTabs';

const statusColors: Record<ContentStatus, string> = {
  [ContentStatus.DRAFT]: '#898989',
  [ContentStatus.PUBLISHED]: '#3ecf8e',
  [ContentStatus.ARCHIVED]: '#f5a623',
};

export const ContentShow: React.FC = () => {
  const { token } = theme.useToken();
  const { queryResult } = useShow<ContentPageDto>({ resource: 'content' });
  const content = queryResult?.data?.data;

  if (!content) {
    return <div style={{ color: token.colorTextSecondary }}>Loading...</div>;
  }

  return (
    <Show resource="content">
      <div style={{ padding: '8px 0' }}>
        <LocalizedContentShow
          record={content}
          fields={[
            { key: 'title', label: 'Title' },
            { key: 'subtitle', label: 'Subtitle' },
            { key: 'content', label: 'Content', textarea: true },
            { key: 'summary', label: 'Summary', textarea: true },
          ]}
        />

        <div
          style={{
            borderTop: `1px solid ${token.colorBorderSecondary}`,
            paddingTop: 16,
          }}
        >
          <Field label="Slug">{content.slug}</Field>
          <Field label="Type">{content.type}</Field>
          <Field label="Status">
            <Tag
              style={{
                borderColor: statusColors[content.status],
                color: statusColors[content.status],
                background: `${statusColors[content.status]}15`,
                borderRadius: 9999,
                padding: '2px 12px',
                fontWeight: 500,
              }}
            >
              {content.status}
            </Tag>
          </Field>
          <Field label="Version">{content.version}</Field>
          <Field label="Current">{content.isCurrent ? 'Yes' : 'No'}</Field>
          <Field label="Format">{content.format}</Field>
          <Field label="Effective Date">{content.effectiveDate ? new Date(content.effectiveDate).toLocaleString() : '—'}</Field>
          <Field label="Expiry Date">{content.expiryDate ? new Date(content.expiryDate).toLocaleString() : '—'}</Field>
          <Field label="Published At">{content.publishedAt ? new Date(content.publishedAt).toLocaleString() : '—'}</Field>
          <Field label="Created At">{new Date(content.createdAt).toLocaleString()}</Field>
          <Field label="Updated At">{new Date(content.updatedAt).toLocaleString()}</Field>
        </div>
      </div>
    </Show>
  );
};
